import axios from 'axios';

// Environment variables
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
const API_KEY = process.env.REACT_APP_API_KEY;
const GEMINI_API_KEY = process.env.REACT_APP_GEMINI_API_KEY;

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'api-key': API_KEY,
    'Content-Type': 'application/json'
  }
});

// Existing functions
export const createPerson = async (personData) => {
  try {
    const response = await api.post('/persons/create', {
      requester: 1,
      ...personData
    });
    return response.data;
  } catch (error) {
    console.error('Error creating person:', error);
    throw error;
  }
};

export const generateAIContent = async (prompt) => {
  const url = `https://generativelanguage.googleapis.com/v1beta/models/gemini-2.0-flash:generateContent?key=${GEMINI_API_KEY}`;
  
  try {
    const response = await axios.post(url, {
      contents: [{
        parts: [{
          text: prompt
        }]
      }]
    });
    return response.data;
  } catch (error) {
    console.error('Error generating AI content:', error);
    throw error;
  }
};

export const getPersonDetails = async () => {
  try {
    const response = await api.get('/persons/get_detail');
    return response.data;
  } catch (error) {
    console.error('Error getting person details:', error);
    throw error;
  }
};

export const getMasterLists = async () => {
  try {
    const response = await api.get('/persons/get');
    return response.data;
  } catch (error) {
    console.error('Error getting person details:', error);
    throw error;
  }
};

export const createAIResponse = async (aiData) => {
  try {
    const response = await api.post('/ais/create', aiData);
    return response.data;
  } catch (error) {
    console.error('Error creating AI response:', error);
    throw error;
  }
};